import Header from '@/components/_rebrand/Header';
import HEADER_PROPS from '@/constants/header';
import { SecurityPageQuery } from '@/graphql';
import SecurityPageQueryDocument from '@/graphql/queries/SecurityPage.gql';
import ModularPageLayout from '@/layouts/ModularPageLayout';
import { getStaticPageProps } from '@/lib/next';
import { ModularPageProps, parseModuleBuilderProps } from '@/modules/ModuleBuilder';
import MasterTemplate from '@/templates/MasterTemplate';

const SecurityPage: PageTemplate<ModularPageProps> = ({ modularPageProps }) => {
  return <ModularPageLayout props={modularPageProps} />;
};

SecurityPage.template = ({ children }) => (
  <MasterTemplate navigation={<Header {...HEADER_PROPS} invert />}>{children}</MasterTemplate>
);

export default SecurityPage;

export const getStaticProps = getStaticPageProps(
  (params) => `security`,
  async ({ client }) => {
    const props = await client.request<SecurityPageQuery>(SecurityPageQueryDocument);

    if (!props.entry) {
      return { notFound: true };
    }

    return {
      props: parseModuleBuilderProps(props),
    };
  },
);
